const MessageList = () =>
  import(/* webpackChunkName: "messaging" */ "./pages/ListPage.vue");
const MessageDetail = () =>
  import(/* webpackChunkName: "messaging" */ "./pages/FormPage.vue");
const MessageIndex = () =>
  import(/* webpackChunkName: "messaging" */ "./pages/IndexPage.vue");

export default [
  {
    path: "/message",
    component: MessageIndex,
    redirect: "/message/list",
    name: "message",
    children: [
      {
        path: "list",
        component: MessageList,
        name: "message.list",
      },
      {
        path: "create",
        component: MessageDetail,
        name: "message.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: MessageDetail,
        name: "message.edit",
        props: { create: false },
      },
    ],
  },
];
